import { createSelector } from '@reduxjs/toolkit';
import { StoreType } from 'store';
import { ActionResult, ConsentReferralUrlParams, Status } from './types';

export const selectActionResult = createSelector(
  (state: StoreType) => state.consent.actionResult,
  (actionResult: ActionResult | undefined) => actionResult,
);

export const selectConsentStatus = createSelector(
  (state: StoreType) => state.consent.status,
  (status: Status) => status,
);

export const selectUserHID = createSelector(
  (state: StoreType) => state.consent.urlQueryParams,
  (urlQueryParams: ConsentReferralUrlParams | undefined) => urlQueryParams?.hid,
);
